<template>
  <main id="products-single" class="site-main">
    <div class="grid-container">
      <div class="single-detail">
        <div class="single-detail__header">
          <div class="grid-x align-bottom">
            <div class="cell shrink">
              <h1 style="font-size: 30px; margin: 0 15px 0 0;">
                {{ product.title }}</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <div class="panel no-padding">
            <div :class="['loading-area', loading ? 'loading' : '']">
              <div :class="['loading-area__content', loading ? 'loading' : '']">
                <tableList :header="tableHeader" :data="tableData"
                           :loading="loading" classes="no-hover"
                           @sort="orderBy"></tableList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

// import moment from 'moment'

export default {
  mixins: [client, paginationUtils],
  data: function () {
    return {
      product: {
        title: 'Product Title'
      },
      action: '/products/' + this.$route.params.id + '/?expand=variants',
      sort: '-created_date',
      loading: true,
      tableHeader: {
        currentSort: '-created_date',
        data: [
          {
            label: 'Product',
            class: 'full'
          },
          {
            label: 'Price',
            class: 'medium'
          },
          {
            label: 'Sku',
            class: 'large'
          },
          {
            label: 'Barcode',
            class: 'large'
          },
          {
            label: 'Inventory',
            class: 'large'
          },
          {
            label: 'Sold',
            class: 'small'
          },
          {
            label: 'Commission',
            class: 'medium'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    buildTable () {
      this.product = this.data

      for (let i = 0; i < this.data.variants.length; i++) {
        let variant = this.data.variants[i]

        if (!variant.deleted) {
          // let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          // '<div class="table-list__image">'
          //
          // if (variant.image !== null && !this.isEmpty(variant.image)) {
          //   // let ext = variant.image.split('.').pop()
          //   //
          //   // variant.image = variant.image.replace('.' + ext, '_100x100.' + ext)
          //   //
          //   // primary += '<div class="table-list__image__inner">'
          //   // primary += '<img src="' + variant.image + '">'
          //   // primary += '</div>'
          // } else {
          //   primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
          // }

          // primary += '</div></div><div class="cell auto">' + variant.title + '</div></div>'

          let inventory = variant.inventory_quantity + ' in stock'

          // if (variant.inventory_policy === 'continue') {
          //   inventory = '<span class="text-medium-gray-color">inventory not tracked</span>'
          // }

          let priceCol = {}
          let commissionCol = {}

          if (this.metas.vendor_field_sell_price.meta_value) {
            priceCol = {
              value: this.formatMoney(variant.price),
              class: 'medium'
            }
          }

          if (this.metas.vendor_field_commissions.meta_value) {
            commissionCol = {
              value: this.formatMoney(variant.commission),
              class: 'medium',
              span: 'focus-text'
            }
          }

          let barcodeCol = {}

          if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com') {
            barcodeCol = {
              value: variant.barcode,
              class: 'large'
            }
          }

          let inventoryCol = {
            value: inventory,
            class: 'large'
          }

          if (this.$store.state.portalSettings.myshopify_domain === 'leivitorloveit.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'mostlymusic.myshopify.com') {
            inventoryCol = {}
          }

          this.tableData.push({
            post: variant.id,
            data: [
              {
                value: variant.title,
                class: 'full'
              },
              priceCol,
              {
                value: variant.sku,
                class: 'large'
              },
              barcodeCol,
              inventoryCol,
              {
                value: variant.sold,
                class: 'small'
              },
              commissionCol
            ]
          })
        }
      }
    }
  },
  computed: {
    metas () {
      return this.$store.state.metas
    }
  },
  created () {
    if (this.$store.state.portalSettings.myshopify_domain === 'leivitorloveit.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'mostlymusic.myshopify.com') {
      this.tableHeader.data[4] = {}
    }

    if (!this.metas.vendor_field_sell_price.meta_value) {
      this.tableHeader.data[1] = {}
    }

    if (!this.metas.vendor_field_commissions.meta_value) {
      this.tableHeader.data[6] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'qualityfood.myshopify.com') {
      this.tableHeader.data[3] = {}
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/productsSingle.vue